module.exports = __webpack_public_path__ + "img/findmykit-lifestyle-2.a4aaf5eb.png";